export default "__VITE_ASSET__BoT1o9xn__"